import { CatButton } from '@blocks-react/components/Button';
import { CreateListButtonType } from './type';

export default function CreateListButton({
  setModal,
  buttonHeading,
  buttonVariant
}: Readonly<CreateListButtonType>) {
  return (
    <CatButton variant={buttonVariant} onClick={() => setModal(true)}>
      {buttonHeading}
    </CatButton>
  );
}
